import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { BoundaryStat, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const renderStat = (stat: BoundaryStat) => (
    <HorizontalContainer className={styles.railStat} key={stat.label}>
        <Wrapper className={styles.railStatLabel}>{stat.label}</Wrapper>

        <Wrapper className={styles.railStatValue}>{stat.value}</Wrapper>
    </HorizontalContainer>
);

const SideRail: FunctionComponent<Props> = ({
    boundaryEmptyBody,
    boundaryStats,
    boundaryTitle,
    className = '',
    nextStepsBody,
    nextStepsTitle,
    testId = TEST_ID
}) => {
    const showStats = boundaryStats && boundaryStats.length > 0;

    return (
        <VerticalContainer className={`${className} ${styles.sideRail}`} testId={testId}>
            <VerticalContainer className={styles.railCard}>
                <Wrapper className={styles.railCardHeading}>{boundaryTitle}</Wrapper>

                {showStats ? (
                    <VerticalContainer className={styles.railCardStats}>
                        {boundaryStats.map(renderStat)}
                    </VerticalContainer>
                ) : (
                    <Wrapper className={styles.railCardBody}>{boundaryEmptyBody}</Wrapper>
                )}
            </VerticalContainer>

            <VerticalContainer className={styles.railCard}>
                <Wrapper className={styles.railCardHeading}>{nextStepsTitle}</Wrapper>

                <Wrapper className={styles.railCardBody}>{nextStepsBody}</Wrapper>
            </VerticalContainer>
        </VerticalContainer>
    );
};

export default SideRail;
